/**
 * @generated SignedSource<<a79cdf9e7e281aaa2b7bece8226fd1ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DefaultFont",
    "kind": "LinkedField",
    "name": "defaultFont",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fontSize",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "QDefaultFontQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "QDefaultFontQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "35667f5927984cb077bc7cd7ce1da6ac",
    "id": null,
    "metadata": {},
    "name": "QDefaultFontQuery",
    "operationKind": "query",
    "text": "query QDefaultFontQuery {\n  defaultFont {\n    id\n    teamId\n    value\n    fontSize\n    unit\n  }\n}\n"
  }
};
})();

node.hash = "4d900cc90bbd8131a0089ad97b43c6af";

export default node;
